import { StringByKey } from '../types/common';
import {
  EDIT,
  EBOOK_INFO,
  INDEX,
  FILE_SHARE,
  FILE_RELEASE,
  HISTORY,
  WEB_DATA,
  FILE_INFO,
  URL_INFO,
  UPLOAD,
  SHARED_LINK_NOTIFICATION,
  STUDENT,
  ADD,
  GROUP,
  colorPointInterpolation,
  STORAGE,
  COPYRIGHT_INFO,
} from './common';
import i18n from '../locales/i18n';

const { t } = i18n;
const BR_TAG = '<br />';

export const VIEW_MY_PROFILE = t('viewMyInformation');
export const LINK_REGISTRATION = t('registerLink');
export const LINK_NAME = t('linkName');
export const EFFECTIVE_DATE = t('effectiveDate');
export const NO_NEW_NOTIFICATION = t('noNewNotifications');
export const NOT_ENOUGH_STORAGE = t('notEnoughStorage');
export const ADD_STORAGE = t('increaseStorage');
export const NEW_SHARED_LINK = t('newSharedLinkAvailable');
export const BUY_STORAGE = t('buyStorage');

export const RECEIVED_NEW_SHARED_LINK = t('newSharedLinksFromOthers', {
  openingEm: '<em>',
  closingEm: '</em>',
  br: BR_TAG,
});
export const NO_SHARED_LINK = t('noShareLink');
export const NO_SHARED_USER = t('noSharedUsers');
export const SHARE = t('share');
export const CREATED_SHARED_LINK = t('shareLinkCreated');
export const LINK_EXPIRATION_DATE = t('linkValidDate');
export const LINK_PWD = t('linkPassword');
export const LEARNING_ANALYSIS = t('learningAnalysis');
export const FILE_SHARE_GUIDE = `${t('shareLinkTip', { br: BR_TAG })}

${t('userShareTip', { br: BR_TAG })}
`;
export const INSERT_SHARE_USER = t('enterEmailAddress');
export const INSERT_SHARE_USER_DESC = t('addMultipleItemsGuide');
export const START_PAGE_TOOLTIP = t('startPageTip', { br: BR_TAG });
export const ENTER_SHARED_URL = t('enterShareUrl');
export const WILL_STOP_SHARING = t('stopSharingConfirmation');
export const ACCESS_RESTRICTED = t('limitedAccessForSharedUsers');
export const ENTER_LINK_NAME = t('enterLinkName');
export const ENTER_FILE_NAME = t('enterFileName');
export const ENTER_URL = t('enterUrl');
export const NOT_SIGNEDUP_USER = `${t('notRegisteredUser')}
${t('sendSignupEmail')}
`;
export const INPUT_KEYWORD = t('enterFileSearchKeyword');
export const OK = t('confirm');
export const CANCEL = t('cancel');
export const UPLOAD_CANCEL = t('cancelUpload');
export const CANCEL_All = t('cancelAll');
export const CLOSE = t('close');
export const CLOSE_POPUP = t('closePopup');
export const LOADING = t('pending');
export const REPLACE = t('replace');
export const KEEP_ALL = t('keepAll');
export const RETRY = t('retry');
export const CALCULATING = t('calculating');
export const VIEW_QUIZ = t('viewQuestion');
export const QUIZ_INFORMATION = t('questionInformation');
export const SOLUTION_INFORMATION = t('solutionInformation');
export const NO_ANSWER = t('noCorrectAnswer');
export const WRONG_ANSWER = t('wrongAnswer');
export const DELETE_HISTORY = t('deleteActivity');
export const NO_ACTIVITY_HISTORY = t('noActivityRecords');
export const OPEN_UPLOAD_LIST = t('openFileUploadList');
export const SHOW_ALL_LINK_NOTI = t('viewAllLinkNotifications');
export const ADD_STUDENT_DESC = `${t('registerCompleteGuide')}
※ ${t('requestApprovalGuide')}`;
export const ENTER_GROUP_NAME = t('enterGroupName');
export const CONVERTING_PAGE = t('pageConverting');
export const BUTTON_TEXT: { [key: string]: readonly string[] } = {
  // confirmBuyStorage: BUY_STORAGE,
  confirmFileReplace: [UPLOAD],
  'exceeded-storage': [t('purchaseMembership'), STORAGE],
} as const;
export const COUNT_SUFFIX = '개의 ';
export const PRINT_RESTRICTION = t('printRestriction');
export const NOTE_DRAG_CAPTURE_RESTRICTION = t('noteDragCaptureRestriction');

export const BODY_TEXT: StringByKey = {
  confirmBuyStorage: `${NOT_ENOUGH_STORAGE}`,
  // confirmBuyStorage: `${NOT_ENOUGH_STORAGE}\n${ADD_STORAGE}`,
  confirmDeleteFile: `${t('discardToTrash')}
  (${t('stopSharePublic')})`,
  confirmDeleteShared: `${t('discardToTrash')}
  (${t('deleteAllViewerData')})`,
  confirmStopSharing: `${WILL_STOP_SHARING}\n(${ACCESS_RESTRICTED})`,
  confirmDeleteHistory: t('deleteAllActivities'),
  confirmEmptyTrash: `${t('deletePermanently')}
  (${t('deletedItemsUnableRecover')})`,
  confirmDelCompletly: `${t('deletePermanently')}
  (${t('deletedItemsUnableRecover')})`,
  confirmFileReplace: `${t('sameFileNameExists')}
  ${t('changeCurrentFile')}, ${t('keepBothFiles', { br: BR_TAG })}`,
  confirmDeleteLibStorage: `${t('discardToTrash')}
  (${t('stopSharePublic')})`,
  confirmDeleteDriveStorage: `${t('discardToTrash')}
  (${t('stopShareCreator', { br: BR_TAG })})`,
  confirmDeleteTrashStorage: `${t('deletePermanently')}
  (${t('deletedItemsUnableRecover')})`,
  confirmEmptyTrashStorage: `${t('deletePermanently')}
  (${t('deletedItemsUnableRecover')})`,
  confirmFileExt: t('uploadEnableFileExt'),
  confirmFileSize: `${t('fileSizeLarge')}
${t('uploadSmaller')}`,
  pdfConverting: `${t('pageConverting')}
${t('waitAMoment')}`,
  confirmRemoveTableRow_student_1: t('deleteStudentInformation'),
  confirmRemoveTableRow_student_2: t('deletePendingInformation'),
  confirmRemoveTableRow_student_4: t('deleteReleasedInfo'),
  confirmRemoveTableRow_student_5: t('deleteExceededInformation'),
  confirmRemoveTableRow_group: t('deleteGroup'),
  confirmRemoveTableRow_groupMember_1: t('deleteStudentInfoFromGroup'),
  confirmRemoveTableRow_groupMember_4: t('deleteReleasedInfoFromGroup'),
  confirmRemoveTableRow_teacher_1: t('deleteTeacherInfo'),
  confirmRemoveTableRow_teacher_3: t('deleteReleasedInfo'),
  confirmRemoveTableRow_teacher_5: t('deleteReleasedInfo'),
  confirmDeleteAllActivity: t('deleteAllActivityRecordsConfirm'),
  confirmDeleteActivity: `${t('deleteCurrentEbookActivity')}
  (${t('deleteActivityRecords', { br: BR_TAG })})`,
  confirmMoveClass: t('moveToStudentManagement'),
  'membership-change-not-allowed': t('membershipChangeOnce'),
  'cancel-change-membership': t('membershipChangeCancelled'),
  'basic-membership-required': t('addAvailableHigherBasic'),
  'current-membership-required': t('selectCurrentMembership'),
  'exceeded-storage': `${t('storageExceededWarning', {
    br: BR_TAG,
    ...colorPointInterpolation,
  })}<br>${t('increaseStorage')}`,
} as const;

export const MODAL_TITLE_LIST: StringByKey = {
  project: `${EBOOK_INFO} ${EDIT}`,
  projectCopyright: COPYRIGHT_INFO,
  projectIndex: `${INDEX}`,
  projectShare: FILE_SHARE,
  projectPublic: FILE_RELEASE,
  projectHistoryList: HISTORY,
  linkRegistration: LINK_REGISTRATION,
  linkPassword: LINK_PWD,
  linkNotification: SHARED_LINK_NOTIFICATION,
  dataRegistration: WEB_DATA,
  resource: FILE_INFO,
  share: FILE_SHARE,
  url: URL_INFO,
  addStudent: `${STUDENT} ${ADD}`,
  addGroup: `${GROUP} ${ADD}`,
} as const;
